import * as React from 'react';

type GridProps = React.PropsWithChildren<{
	templateColumns?: string,
	templateRows?: string,
	autoColumns?: string,
	autoRows?: string,
	autoFlow?: string,
	gap?: string,
	className?: string
	style?: React.CSSProperties
}>

export const Grid = React.forwardRef<HTMLDivElement, GridProps>(
	function Grid(props, ref) {
		const {
			gap,
			autoFlow,
			autoRows,
			templateRows,
			autoColumns,
			templateColumns,
			style,
			...rest
		} = props;

		const styles: React.CSSProperties = {
			display: 'grid',
			gridTemplateRows: templateRows,
			gridTemplateColumns: templateColumns,
			gridAutoColumns: autoColumns,
			gridAutoRows: autoRows,
			gridAutoFlow: autoFlow,
			gap: gap,
			...style
		};

		return <div {...rest} ref={ref} style={styles} />;
	},
);
